
// Multilingual content structure for Bad Gyal Madrid steps
export const badGyalMadridContent = {
  hero: {
    title: {
      en: "Bad Gyal - Madrid",
      es: "Bad Gyal - Madrid",
      ca: "Bad Gyal - Madrid"
    },
    description: {
      en: "Everything you need to know about accessing, validating, and managing your tickets for Bad Gyal's concerts in Madrid.",
      es: "Todo lo que necesitas saber sobre acceder, validar y gestionar tus entradas para los conciertos de Bad Gyal en Madrid.",
      ca: "Tot el que necessites saber sobre accedir, validar i gestionar les teves entrades per als concerts de Bad Gyal a Madrid."
    }
  },
  steps: [
    {
      id: "how-to-access",
      number: "01",
      title: {
        en: "How to access",
        es: "Cómo acceder",
        ca: "Com accedir"
      },
      description: {
        en: "How to access Bad Gyal's concerts in Madrid",
        es: "Cómo acceder a los conciertos de Bad Gyal en Madrid",
        ca: "Com accedir als concerts de Bad Gyal a Madrid"
      },
      content: {
        intro: {
          en: "Access to the event is only possible with a validated ticket and its QR code visible in AccessTicket.",
          es: "Acceder al evento solo es posible con una entrada validada y su QR visible en AccessTicket.",
          ca: "Accedir a l'esdeveniment només és possible amb una entrada validada i el seu QR visible a AccessTicket."
        },
        points: {
          en: [
            "Remember that the QR code will appear on the day of the event",
            "If you have more than one ticket on your mobile device, each ticket requires its own validation. You will need to provide companion details for each ticket",
            "Only tickets with complete validation can access the venue. Make sure to do this before arriving at the main entrance",
            "Screenshots will not be accepted at the entrance",
          ],
          es: [
            "Recuerda que el QR aparecerá el propio día del evento",
            "Si tienes más de una entrada en tu dispositivo móvil, cada entrada requiere su validación. Necesitarás proporcionar datos de acompañante para cada entrada",
            "Solo las entradas con validación completa pueden acceder al recinto. Asegúrate de hacerlo antes de llegar al acceso principal",
            "No se aceptarán capturas de pantalla en la entrada",
          ],
          ca: [
            "Recorda que el QR apareixerà el propi dia de l'esdeveniment",
            "Si tens més d'una entrada al teu dispositiu mòbil, cada entrada requereix la seva validació. Necessitaràs proporcionar dades d'acompanyant per a cada entrada",
            "Només les entrades amb validació completa poden accedir al recinte. Assegura't de fer-ho abans d'arribar a l'accés principal",
            "No s'acceptaran captures de pantalla a l'entrada",
          ]
        },
        sections: [
          {
            title: {
              en: "Schedule",
              es: "Horarios",
              ca: "Horaris"
            },
            points: {
              en: [
                "Saturday 11th and Sunday 12th of April",
                "Doors open at 7:00 PM",
                "Show starts at 9:00 PM",
              ],
              es: [
                "Sábado 11 y domingo 12 de abril",
                "Apertura de puertas 19:00h",
                "Inicio show 21:00h",
              ],
              ca: [
                "Dissabte 11 i diumenge 12 d'abril",
                "Obertura de portes 19:00h",
                "Inici show 21:00h",
              ]
            }
          }
        ],
        warning: {
          en: "Important",
          es: "Importante",
          ca: "Important"
        },
        warningDetails: {
          en: [
            "Exit does not allow re-entry",
          ],
          es: [
            "La salida no admite retorno",
          ],
          ca: [
            "La sortida no admet retorn",
          ]
        }
      },
      image: "https://assets.primaverasound.com/psweb/n45wc4xi2c6msy5c9uan_1775731567443.png"
    },
    {
      id: "practical-info",
      number: "02",
      title: {
        en: "Practical information",
        es: "Información práctica",
        ca: "Informació pràctica"
      },
      description: {
        en: "Essential event details",
        es: "Detalles esenciales del evento",
        ca: "Detalls essencials de l'esdeveniment"
      },
      content: {
        intro: {
          en: "Everything you need to know about the event.",
          es: "Todo lo que necesitas saber sobre el evento.",
          ca: "Tot el que necessites saber sobre l'esdeveniment."
        },
        sections: [
          {
            title: {
              en: "When will the event take place?",
              es: "¿Cuándo tendrá lugar el evento?",
              ca: "Quan tindrà lloc l'esdeveniment?"
            },
            points: {
              en: ["April 11th and 12th"],
              es: ["El 11 y 12 de abril"],
              ca: ["L'11 i 12 d'abril"]
            }
          },
          {
            title: {
              en: "What is the exact location?",
              es: "¿Cuál es la localización exacta?",
              ca: "Quina és la localització exacta?"
            },
            points: {
              en: [
                "Movistar Arena",
                "Av. de Felipe II, s/n, Salamanca",
                "28009 Madrid"
              ],
              es: [
                "Movistar Arena",
                "Av. de Felipe II, s/n, Salamanca",
                "28009 Madrid"
              ],
              ca: [
                "Movistar Arena",
                "Av. de Felipe II, s/n, Salamanca",
                "28009 Madrid"
              ]
            }
          },
          {
            title: {
              en: "What are the opening hours?",
              es: "¿Cuál es el horario?",
              ca: "Quin és l'horari?"
            },
            points: {
              en: [
                "Doors 7:00 PM",
                "Bad Gyal 9:00 PM"
              ],
              es: [
                "Puertas 19:00h",
                "Bad Gyal 21:00h"
              ],
              ca: [
                "Portes 19:00h",
                "Bad Gyal 21:00h"
              ]
            }
          },
          {
            title: {
              en: "Until when can I access the event?",
              es: "¿Hasta cuándo puedo acceder al evento?",
              ca: "Fins quan puc accedir a l'esdeveniment?"
            },
            points: {
              en: ["Up to 15 minutes before the end of the event."],
              es: ["Hasta 15min antes de que finalice el evento."],
              ca: ["Fins a 15min abans que finalitzi l'esdeveniment."]
            }
          },
          {
            title: {
              en: "Is there a minimum age requirement to attend?",
              es: "¿Hay una edad mínima para poder acceder?",
              ca: "Hi ha una edat mínima per poder accedir?"
            },
            points: {
              en: ["No, but children aged 0 to 13 must be accompanied by an adult."],
              es: ["No, pero los menores de 0 a 13 años deben acceder acompañados por un adulto."],
              ca: ["No, però els menors de 0 a 13 anys han d'accedir acompanyats per un adult."]
            }
          },
          {
            title: {
              en: "I have purchased more than one ticket. What do I need to do to access the event?",
              es: "He comprado más de una entrada. ¿Qué tengo que hacer para acceder?",
              ca: "He comprat més d'una entrada. Què he de fer per accedir?"
            },
            points: {
              en: [
                "Each ticket requires its own validation. You will need to provide companion details for each ticket.",
                "Only tickets with complete validation can access the venue."
              ],
              es: [
                "Cada entrada requiere su validación. Necesitarás proporcionar datos de acompañante para cada entrada.",
                "Solo las entradas con validación completa pueden acceder al recinto."
              ],
              ca: [
                "Cada entrada requereix la seva validació. Necessitaràs proporcionar dades d'acompanyant per a cada entrada.",
                "Només les entrades amb validació completa poden accedir al recinte."
              ]
            }
          },
          {
            title: {
              en: "If I have more than one ticket in my AccessTicket account, do we all have to enter together?",
              es: "Si tengo más de una entrada en mi cuenta de AccessTicket, ¿tenemos que acceder todas las personas juntas?",
              ca: "Si tinc més d'una entrada al meu compte d'AccessTicket, hem d'accedir totes les persones juntes?"
            },
            points: {
              en: ["Yes, if you have multiple tickets in your AccessTicket account, all attendees must enter at the same time."],
              es: ["Sí, si tienes varias entradas en tu cuenta de AccessTicket, todas las personas deben acceder a la vez."],
              ca: ["Sí, si tens diverses entrades al teu compte d'AccessTicket, totes les persones han d'accedir alhora."]
            }
          },
          {
            title: {
              en: "Are tickets transferable?",
              es: "¿Las entradas son transferibles?",
              ca: "Les entrades són transferibles?"
            },
            points: {
              en: ["Yes, ticket transfers are enabled for this event, up to 24 hours before the event starts."],
              es: ["Sí, la transferencia de entradas está habilitada para este evento, hasta 24h antes de que inicie el evento."],
              ca: ["Sí, la transferència d'entrades està habilitada per a aquest esdeveniment, fins a 24h abans que comenci l'esdeveniment."]
            }
          },
          {
            title: {
              en: "Can I access with a screenshot?",
              es: "¿Podré acceder con una captura de pantalla?",
              ca: "Podré accedir amb una captura de pantalla?"
            },
            points: {
              en: ["No, a screenshot will not allow you to access the event."],
              es: ["No, una captura de pantalla no te servirá para acceder al evento."],
              ca: ["No, una captura de pantalla no et servirà per accedir a l'esdeveniment."]
            }
          },
          {
            title: {
              en: "Are there accessible tickets?",
              es: "¿Hay entradas accesibles?",
              ca: "Hi ha entrades accessibles?"
            },
            points: {
              en: ["Yes, there is a PMR ticket for those who need this type of entry. You can write to tours@primaverasound.com for more information."],
              es: ["Sí, existe un ticket PMR para aquellas personas que necesiten este tipo de entrada. Puedes escribir a tours@primaverasound.com para obtener más información."],
              ca: ["Sí, existeix un ticket PMR per a aquelles persones que necessitin aquest tipus d'entrada. Pots escriure a tours@primaverasound.com per obtenir més informació."]
            }
          }
        ]
      },
      fullWidth: true
    },
    {
      id: "tickets",
      number: "03",
      title: {
        en: "My tickets",
        es: "Mis tickets",
        ca: "Els meus tiquets"
      },
      description: {
        en: "Information about your tickets",
        es: "Información sobre tus entradas",
        ca: "Informació sobre les teves entrades"
      },
      content: {
        intro: {
          en: "Access to the event is only possible with a validated ticket and its QR code visible in AccessTicket. Remember that the QR code will appear on the day of the event. Screenshots will not be accepted at the entrance.",
          es: "Acceder al evento solo es posible con una entrada validada y su QR visible en AccessTicket. Recuerda que el QR aparecerá el propio día del evento. No se aceptarán capturas de pantalla en la entrada.",
          ca: "Accedir a l'esdeveniment només és possible amb una entrada validada i el seu QR visible a AccessTicket. Recorda que el QR apareixerà el propi dia de l'esdeveniment. No s'acceptaran captures de pantalla a l'entrada."
        },
        sections: [
          {
            title: {
              en: "Your Ticket Information",
              es: "Información de tu Entrada",
              ca: "Informació de la teva Entrada"
            },
            points: {
              en: [
                "Owner data is automatically attached to your ticket",
                "Each ticket carries the validation information of all attendees",
                "QR codes will be visible on the day of the event",
                "No screenshots will be accepted at the entrance",
              ],
              es: [
                "Los datos del propietario se adjuntan automáticamente a tu entrada",
                "Cada entrada lleva la información de validación de todos los asistentes",
                "Los códigos QR serán visibles el día del evento",
                "No se aceptarán capturas de pantalla en la entrada",
              ],
              ca: [
                "Les dades del propietari s'adjunten automàticament a la teva entrada",
                "Cada entrada porta la informació de validació de tots els assistents",
                "Els codis QR seran visibles el dia de l'esdeveniment",
                "No s'acceptaran captures de pantalla a l'entrada",
              ]
            },
          },
          {
            title: {
              en: "Multiple Tickets? Each One Needs Validation!",
              es: "¿Múltiples entradas? ¡Cada Una Necesita Validación!",
              ca: "Múltiples entrades? Cada Una Necessita Validació!"
            },
            points: {
              en: [
                "Each additional ticket requires validation",
                "You will need to provide companion details for each ticket",
                "Only tickets with complete validation can access the event",
                "It is not possible to access with a screenshot",
              ],
              es: [
                "Cada entrada adicional requiere validación",
                "Necesitarás proporcionar datos de acompañante para cada entrada",
                "Solo las entradas con validación completa pueden acceder al evento",
                "No es posible acceder con una captura de pantalla",
              ],
              ca: [
                "Cada entrada addicional requereix validació",
                "Necessitaràs proporcionar dades d'acompanyant per a cada entrada",
                "Només les entrades amb validació completa poden accedir a l'esdeveniment",
                "No és possible accedir amb una captura de pantalla",
              ]
            },
          },
          {
            title: {
              en: "Ticket Management",
              es: "Gestión de Entradas",
              ca: "Gestió d'Entrades"
            },
            points: {
              en: [
                "View all your tickets in the AccessTicket app",
                "Each ticket shows its validation status",
                "The transfer option is enabled for this event",
              ],
              es: [
                "Ve todas tus entradas en la app AccessTicket",
                "Cada entrada muestra el estado de validación",
                "La opción de transferencia está habilitada para este evento",
              ],
              ca: [
                "Veu totes les teves entrades a l'app AccessTicket",
                "Cada entrada mostra l'estat de validació",
                "L'opció de transferència està habilitada per a aquest esdeveniment",
              ]
            },
          },
        ],
      },
      image: 'https://assets.primaverasound.com/psweb/568o2twrgblmr3dqw6b8_1772793286764.png'
    },
    {
      id: "ticket-transfer",
      number: "04",
      title: {
        en: "Ticket transfer",
        es: "Transferencia de tickets",
        ca: "Transferència de tiquets"
      },
      description: {
        en: "How to transfer your tickets",
        es: "Cómo transferir tus entradas",
        ca: "Com transferir les teves entrades"
      },
      content: {
        intro: {
          en: "Transfers for Bad Gyal concert tickets are enabled. Remember that this process is not reversible, so once transferred you will not be able to recover your ticket. Make sure to include the recipient's email address correctly.",
          es: "La transferencia para las entradas del concierto de Bad Gyal están habilitadas. Recuerda que este proceso no es reversible, por lo que una vez transferida no podrás recuperar tu entrada. Asegúrate de incluir el correo electrónico del receptor correctamente.",
          ca: "La transferència per a les entrades del concert de Bad Gyal estan habilitades. Recorda que aquest procés no és reversible, per la qual cosa un cop transferida no podràs recuperar la teva entrada. Assegura't d'incloure el correu electrònic del receptor correctament."
        },
        warning: {
          en: "Important",
          es: "Importante",
          ca: "Important"
        },
        warningDetails: {
          en: [
            "Transfers will be available until 24 hours before the event date.",
          ],
          es: [
            "La transferencia estará disponible hasta 24h antes de la fecha del evento.",
          ],
          ca: [
            "La transferència estarà disponible fins a 24h abans de la data de l'esdeveniment.",
          ]
        },
      },
      image: "https://assets.primaverasound.com/psweb/1n8xbt4y6vaq3bdjmpp2_1770029093197.jpg"
    },
    {
      id: "how-to-get-there",
      number: "05",
      title: {
        en: "How to get there",
        es: "Cómo llegar",
        ca: "Com arribar-hi"
      },
      description: {
        en: "Transport options to the venue",
        es: "Opciones de transporte al recinto",
        ca: "Opcions de transport al recinte"
      },
      content: {
        intro: {
          en: "Explore all transport options to make your journey to and from the event easier.",
          es: "Explora todas las opciones de transporte para facilitar tu camino de ida y vuelta al evento.",
          ca: "Explora totes les opcions de transport per facilitar el teu camí d'anada i tornada a l'esdeveniment."
        },
        sections: [
          {
            title: {
              en: "Metro",
              es: "Metro",
              ca: "Metro"
            },
            points: {
              en: ["The closest stops are Goya (L4 and L2) and O'Donnell (L6)"],
              es: ["Las paradas más cercanas son Goya (L4 y L2) y O'Donnell (L6)"],
              ca: ["Les parades més properes són Goya (L4 i L2) i O'Donnell (L6)"]
            }
          },
          {
            title: {
              en: "Bus",
              es: "Autobús",
              ca: "Autobús"
            },
            points: {
              en: ["The closest EMT lines are 143, 56, 2, 71, 28, 21, 53, 15, 63, 43, 30, 29 and C"],
              es: ["Las líneas más cercanas son 143, 56, 2, 71, 28, 21, 53, 15, 63, 43, 30, 29 y C de la EMT"],
              ca: ["Les línies més properes són 143, 56, 2, 71, 28, 21, 53, 15, 63, 43, 30, 29 i C de l'EMT"]
            }
          },
          {
            title: {
              en: "BiciMAD",
              es: "BiciMAD",
              ca: "BiciMAD"
            },
            points: {
              en: ["There are two: one in Plaza de Felipe II, across Calle Narváez, and another in Calle Jorge Juan, near the Casa de la Moneda."],
              es: ["Tienes dos: una en la plaza de Felipe II, cruzando la Calle Narváez, y otra en la calle Jorge Juan, a la altura de la Casa de la Moneda."],
              ca: ["En tens dues: una a la plaça de Felipe II, creuant el Carrer Narváez, i una altra al carrer Jorge Juan, a l'alçada de la Casa de la Moneda."]
            }
          }
        ]
      },
      fullWidth: true
    },
    {
      id: "allowed-prohibited-items",
      number: "06",
      title: {
        en: "Allowed / Prohibited Items",
        es: "Objetos permitidos / prohibidos",
        ca: "Objectes permesos / prohibits"
      },
      description: {
        en: "What you can and cannot bring",
        es: "Qué puedes y no puedes traer",
        ca: "Què pots i no pots portar"
      },
      content: {
        intro: {
          en: "",
          es: "",
          ca: ""
        },
      },
      image: "https://assets.primaverasound.com/psweb/ila4i75ulnrclbjx3vee_1775814841929.png",
      fullWidth: true
    }
  ]
};
